export default {
  app: {
    privacy: {
      policy: 'politica de confidențialitate',
      expansive: 'Prin utilizarea Expansive, sunteți de acord cu {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesiunea a expirat',
    sessionExpiredDescription:
      'Sesiunea dvs. a expirat. Vă rugăm să vă autentificați din nou pentru a continua să utilizați aplicația.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Alegeți limba',
      chooseLanguageDescription:
        'Alegeți limba preferată pentru aplicație. Aceasta va schimba limba interfeței și a conținutului.',
    },
    userSelection: {
      cancel: 'Anulează',
      createNewUser: 'Numele lor nu este listat',
      newUser: 'Utilizator nou',
      selectAnExistingUser: 'Selectați un utilizator existent',
      selectUserHint: 'Selectați un utilizator existent sau creați unul nou pentru a continua.',
      startTypingToSearch: 'Începeți să tastați...',
    },
    verification: {
      codeVerification: {
        continue: 'Continuă',
        header: 'Introduceți codul de acces la locație',
        invalidCode: 'Cod invalid, încercați din nou.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Continuă fără verificarea locației',
        enterSiteAccessCode: 'Introduceți codul de acces la locație',
        locationNotEnabledOrAvailable: 'De ce văd asta?',
        notAvailable: {
          description: 'Locația GPS nu este acceptată pe acest dispozitiv.',
          header: 'Locația nu este acceptată',
        },
        notEnabled: {
          description:
            'Serviciile de localizare nu sunt activate sau permisiunea nu a fost acordată.',
          header: 'Locația nu este activată',
        },
        notVerified: {
          description: 'GPS indică faptul că nu sunteți la locație.',
          header: 'Locație neverificată',
        },
        tryAgain: 'Încercați din nou',
        unavailable: {
          description: 'Nu am putut verifica locația GPS.',
          header: 'Locație indisponibilă',
        },
        unknown: {
          description: 'Nu putem determina locația dvs.',
          header: 'Locație necunoscută',
        },
        verified: {
          description: 'GPS indică faptul că sunteți la locație.',
          header: 'Locație verificată',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Niciun activ găsit',
        emptyDescription: 'Nu există active asociate cu această comandă de lucru.',
        warrantyParts: 'Garanția pieselor expiră',
        serialNumber: 'Număr de serie',
        none: '<niciunul>',
      },
      updates: {
        emptyTitle: 'Nicio actualizare găsită',
        emptyDescription: 'Nu există actualizări pentru această comandă de lucru.',
        unknownUser: 'Utilizator necunoscut',
        none: 'Niciuna',
        addComment: {
          buttonLabel: 'Adaugă comentariu',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Pericole',
          no: 'Nu',
          yes: 'Da',
        },
      },
    },
    attachmentsList: {
      attachments: 'Atașamente',
      documents: 'Documente',
      siteDocuments: 'Documente de șantier',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Pericole',
        induction: 'Inducție',
        safeToProceed: 'Sigur de continuat',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Data scadenței',
        activeSessions: 'Sesiuni active',
        activeSessionsDescription:
          'Sunteți deja autentificat în următoarele comenzi de lucru. Trebuie să vă deconectați de la aceste comenzi înainte de a vă autentifica la una nouă.',
        resumeSession: 'Reia',
        startTime: 'Început la',
        unexpectedErrorTitle: 'Eroare neașteptată',
        unexpectedErrorMessage:
          'A apărut o eroare neașteptată la crearea sesiunilor. Vă rugăm să încercați mai târziu.',
        engineerNotFound: 'Inginer negăsit',
        engineerNotFoundDescription:
          'Inginerul pe care încercați să îl autentificați nu a fost găsit în sistem. Contactați administratorul.',
      },
      verification: {
        code: {
          description:
            'Pentru a vă autentifica, obțineți codul de 4 cifre de la managerul de șantier sau persoana desemnată.',
        },
        geo: {
          continue: 'Continuă',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Vă rugăm să obțineți codul de acces de la managerul site-ului sau contactul desemnat pentru a finaliza vizita.',
            checkOut: 'Deconectare',
            completeBeforeLeaving: 'Vă rugăm să completați următorul formular înainte de a pleca.',
            continue: 'Continuă',
            noResolutionSelected: 'Selectați o rezoluție înainte de a continua.',
            quoteRequired: {
              hint: 'Vizita finalizată, ofertă de urmat',
              label: 'Ofertă necesară',
            },
            returnVisitRequired: {
              hint: 'Vom reveni pentru a finaliza',
              label: 'Vizită suplimentară necesară',
            },
            serviceCompleted: {
              hint: 'Nicio acțiune suplimentară necesară',
              label: 'Serviciu finalizat',
            },
            uploadCheckout: 'Încărcați un fișier, fotografie sau video',
            visitNotes: 'Note vizită',
            workOrderResolution: 'Rezoluție comandă de lucru',
            enterNotes: 'Introduceți notițe aici...',
            errors: {
              timedOut: 'Timp expirat, peste 30 de secunde. Încercați din nou.',
              closingSession: 'Eroare la închiderea sesiunii',
            },
          },
          success: {
            description:
              'Vă mulțumim pentru vizită la {site}. | {site} are încă 1 comandă de lucru deschisă. | {site} are încă {count} comenzi de lucru deschise.',
            endVisit: 'Încheie vizita',
            header: 'V-ați deconectat cu succes',
            viewWorkOrders: 'Autentificați-vă la altă comandă de lucru',
          },
          verification: {
            code: {
              description:
                'Pentru a vă deconecta, obțineți codul de 4 cifre de la managerul de șantier sau persoana desemnată.',
              continue: 'Continuă',
            },
            geo: {
              checkOut: 'Deconectare',
              continue: 'Continuă',
            },
          },
        },
        detail: {
          assets: 'Active',
          call: 'Apelează',
          checkOut: 'Deconectare',
          closed: 'Închis',
          details: 'Detalii',
          dueBy: 'Data scadenței',
          manageEngineers: 'Gestionează inginerii',
          notAvailable: 'Indisponibil',
          pointOfContact: 'Persoană de contact',
          siteAccessTimes: 'Ore acces șantier',
          siteAccessInstructions: 'Instrucțiuni de acces',
          siteAddress: 'Adresă șantier',
          siteNotes: 'Note șantier',
          siteTelephone: 'Telefon șantier',
          siteLocation: 'Locație șantier',
          updates: 'Actualizări',
          more: 'Mai mult',
          mismatchErrorTitle: 'Eroare comandă de lucru',
          mismatchErrorMessage:
            'Comanda de lucru la care încercați să accesați nu corespunde cu cea la care sunteți autentificat. Verificați comanda și încercați din nou.',
          siteDocuments: 'Documente șantier',
          validFrom: 'Valabil de la',
          validUntil: 'Valabil până la',
          documentName: 'Nume document',
          documentType: 'Tip document',
          attachments: 'Fișiere comandă de lucru',
          download: 'Descarcă',
          workDetails: 'Detalii lucrare',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Adaugă inginer asistent',
            assistantEngineers: 'Ingineri asistenți',
            description:
              'Din motive de securitate, specificați numele fiecărui inginer de pe șantier.',
            editMainEngineer: 'Editează inginerul principal',
            errors: {
              creatingEngineer: 'Eroare la crearea inginerului',
              creatingSession: 'Eroare la crearea sesiunii',
            },
            header: 'Ingineri pe șantier',
            mainEngineer: 'Inginer principal',
            newAssistantEngineer: 'Introduceți numele complet',
            next: 'Următorul',
            removeEngineer: 'Elimină inginerul',
            selectExistingAssistantEngineer: 'Începeți să tastați numele',
          },
          index: {
            description:
              'Din motive de securitate, specificați numele fiecărui inginer de pe șantier.',
            errorCreatingEngineer: 'Eroare la crearea inginerului, încercați din nou.',
            header: 'Ingineri pe șantier',
            hintMainEngineer: 'Introduceți numele complet al inginerului principal',
            newMainEngineer: 'Inginer principal nou',
            next: 'Următorul',
            selectExistingMainEngineer: 'Selectați un inginer principal existent',
            yes: 'Da',
            no: 'Nu',
            mainEngineerLabel: 'Sunteți inginerul principal?',
          },
        },
        index: {
          callUsOn: 'Sunați-ne la {phoneNumber}',
          description: 'Nu găsiți ce căutați?',
          dueBy: 'Data scadenței',
          header: 'Selectați comanda de lucru',
          notAvailable: 'Indisponibil',
          searchWorkOrders: 'Căutați comenzi de lucru...',
        },
        manageEngineers: {
          manageEngineers: 'Gestionează inginerii',
          notWorking: 'Lucrători inactivi',
          pause: 'Pauză',
          resume: 'Reia',
          workingNow: 'Lucrători activi',
          startTime: 'Ora de început',
          endTime: 'Ora de sfârșit',
          duration: 'Durată',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              'Vă rugăm să oferiți feedback pentru a ne ajuta să îmbunătățim serviciile.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Atașamente',
            submissionLabel: 'Trimite feedback',
          },
          hazards: {
            back: 'Înapoi',
            hazards: 'Pericole',
            next: 'Următorul',
            no: 'Nu',
            noTasksForHazard: 'Nu există sarcini pentru acest pericol.',
            yes: 'Da',
          },
          induction: {
            continue: 'Continuă',
            induction: 'Inducție',
          },
          index: {
            checkIn: 'Autentificare',
            description: 'Vă rugăm să completați evaluarea riscurilor pentru lucrarea selectată.',
            fail: 'Eroare la procesarea verificărilor de început.',
            haltMessage:
              'Riscuri potențiale detectate. Opriți lucrul, consultați ghidurile de siguranță și contactați supervizorul.',
            header: 'Verificări de început',
            endVisit: 'Încheie vizita',
            leaveFeedback: 'Lasă feedback',
          },
          safeToProceed: {
            continue: 'Continuă',
            safeToProceed: 'Sigur de continuat',
          },
        },
      },
    },
    index: {
      title: 'Bun venit',
      description: 'Scanați codul QR la locație pentru a începe.',
    },
    login: {
      errorTitle: 'Eroare neașteptată',
      errorMessage: 'A apărut o eroare neașteptată. Încercați să scanați din nou codul QR.',
    },
    unauthenticated: {
      welcome: {
        title: 'Bun venit la {site}',
        description:
          'Înainte de a vă arăta comenzi de lucru, trebuie să vă verificăm detaliile. Apăsați butonul de mai jos pentru a continua.',
        next: 'Continuă',
      },
      index: {
        errorTitle: 'Eroare neașteptată',
        errorMessage: 'A apărut o eroare neașteptată. Încercați să scanați din nou codul QR.',
      },
      contractor: {
        title: 'Pentru cine lucrați?',
        contractor: 'Contractor',
        contractorLabel: 'Începeți să tastați numele companiei',
        contractorHint: 'Trebuie să introduceți cel puțin 3 caractere pentru a vedea rezultatele',
        defaultSelectPlaceholder: '--Vă rugăm să selectați--',
        next: 'Următorul',
      },
      user: {
        title: 'Cine sunteți?',
        cancel: 'Anulează',
        createNewUserLabel: 'Numele meu nu este listat',
        existingUserLabel: 'Începeți să tastați numele',
        existingUserHint: 'Trebuie să introduceți cel puțin 3 caractere pentru a vedea rezultatele',
        newUserLabel: 'Introduceți numele complet',
        next: 'Următorul',
        user: 'Utilizator',
      },
      verification: {
        methods: {
          add: {
            add: 'Adaugă metodă de verificare',
            defaultSelectPlaceholder: '--Vă rugăm să selectați--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Aveți deja o cerere în așteptare pentru această metodă de verificare. Adăugarea uneia noi o va suprascrie.',
            method: 'Metodă',
            methodLabel: 'Metodă',
            mobileCountryHint: 'Selectați codul de țară',
            mobileCountryLabel: 'Cod țară mobil',
            mobileHint: 'Introduceți numărul de mobil',
            mobileLabel: 'Mobil',
            title: 'Adaugă metodă de verificare',
          },
          confirm: {
            confirm: 'Confirmă',
            description: 'Confirmați metoda de verificare pentru a continua.',
            label: 'Introduceți codul',
            resend: 'Retrimite',
            resendPrompt: 'Nu ați primit codul?',
            title: 'Confirmare metodă de verificare',
          },
          confirmed: {
            description:
              'Veți fi notificat când această metodă de verificare va fi aprobată de administrator și o veți putea folosi.',
            forceApproval: 'Până la aprobat, nu puteți accesa comenzile de lucru.',
            nonForceApproval: 'Între timp, puteți accesa comenzile de lucru cu acces redus.',
            nonForceApprovalButtonLabel: 'Continuă cu acces redus',
            title: 'Așteaptă aprobat',
          },
          addNew: 'Adaugă metodă nouă de verificare',
          description:
            'Trebuie să vă verificăm identitatea pentru a vă oferi acces complet la comanda de lucru.',
          email: 'Email',
          hint: 'Vom trimite un link către metoda de verificare selectată pentru acces complet. Pentru modificări, contacta��i administratorul.',
          label: 'Selectați o metodă de verificare',
          next: 'Următorul',
          pendingHint: 'Așteaptă aprobarea administratorului',
          sms: 'SMS',
          title: 'Verificare',
        },
        optional: {
          hint: 'Verificarea detaliilor vă oferă acces complet la comanda de lucru',
          label: 'Doriți să vă verificați detaliile?',
          next: 'Următorul',
          no: 'Nu',
          noHint: 'Nu vreau să-mi verific detaliile și continui cu acces redus la comanda de lucru',
          title: 'Verificare',
          yes: 'Da',
          yesHint: 'Vreau să-mi verific detaliile și să am acces complet la comanda de lucru',
        },
        sent: {
          description:
            'Un link de autentificare a fost trimis la {identifier}. Accesați linkul pentru a finaliza autentificarea.',
          title: 'Link de autentificare trimis',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Ieri',
      today: 'Astăzi',
      days: {
        monday: 'Luni',
        tuesday: 'Marți',
        wednesday: 'Miercuri',
        thursday: 'Joi',
        friday: 'Vineri',
        saturday: 'Sâmbătă',
        sunday: 'Duminică',
      },
      months: {
        january: 'Ianuarie',
        february: 'Februarie',
        march: 'Martie',
        april: 'Aprilie',
        may: 'Mai',
        june: 'Iunie',
        july: 'Iulie',
        august: 'August',
        september: 'Septembrie',
        october: 'Octombrie',
        november: 'Noiembrie',
        december: 'Decembrie',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Ceva nu a mers bine',
      message: 'Încercați să scanați din nou codul QR.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Utilizator necunoscut',
      },
      none: 'Niciuna',
      types: {
        stateTransition: 'Status schimbat',
        contractorAssigned: 'Contractor atribuit',
        engineerAssigned: 'Inginer atribuit',
        serviceAssigned: 'Serviciu atribuit',
        priorityChanged: 'Prioritate schimbată',
        actionableDateChanged: 'Data acțiunii schimbată',
        dueDateChanged: 'Data scadentă schimbată',
        etaDateChanged: 'Data estimată de sosire schimbată',
        spendLimitApproved: 'Limită de cheltuieli aprobată',
        spendLimitCancelled: 'Cerere limită de cheltuieli anulată',
        spendLimitRejected: 'Limită de cheltuieli respinsă',
        spendLimitRequested: 'Limită de cheltuieli solicitată',
        jobSheetUploaded: 'Fișă de lucru încărcată',
        slaAlertSent: 'Alertă SLA depășită',
        issuedWorkPermit: 'Permis de lucru emis',
        requestForServiceSent: 'Cerere de serviciu trimisă',
        comment: 'Comentariu adăugat',
        unknown: 'Eveniment necunoscut',
      },
      labels: {
        actionableDate: 'Data acțiunii',
        comment: 'Comentariu',
        file: 'Fișier',
        contractor: 'Contractor',
        dueDate: 'Data scadentă',
        etaDate: 'Data estimată de sosire',
        engineer: 'Inginer',
        priority: 'Prioritate',
        requestForService: 'Cerere de serviciu',
        service: 'Serviciu',
        spendLimit: 'Limită de cheltuieli',
        status: 'Status',
        workPermit: 'Permis de lucru',
      },
    },
  },
}
